import React, { useRef } from 'react';
import { ReactComponent as ChevronDoubleDown } from '../svg/chevrons-down-double.svg';
import { connect } from 'react-redux';
import { pageLoading } from '../redux/selectors/pagesSelectors';
import Skeleton from 'react-loading-skeleton';
import { cartMainProduct } from '../redux/selectors/cartSelector';
import { formatNumberWithSeparator } from "../lib/formatNumberWithSeparator";
import SafeHtml from './General/SafeHtml';

function TotalBill({ pageLoading, cartTotals }) {
    const proceedButton = useRef();
    const goToTop = () => {
        document.body.scrollIntoView(false);
    };

    return (
        <div
            className={
                'flex flex--space-between flex--align-baseline header__link-border header__link-border--space-32 header__total'
            }
        >
            <button
                type={'button'}
                onClick={() => goToTop()}
                className={'button--reset button--icon-move-down no-wrap'}
                ref={proceedButton}
            >
                <span className={'text-3 color--blue'}>
                    Total {pageLoading ? <Skeleton width={50} inline={true} /> :  <>
                    <SafeHtml as={'span'} html={cartTotals.signHtml} />
                    {formatNumberWithSeparator(cartTotals.totalWithPromo, ',', 2)}
                </>}
                </span>
                <span className={'visually-hidden'}>Proceed to payment</span>
                <ChevronDoubleDown className={'icon size-20 color--blue'} />
            </button>
        </div>
    );
}

const mapStateToProps = (state) => ({
    pageLoading: pageLoading(state),
    mainProduct: cartMainProduct(state),
});

export default connect(mapStateToProps, null)(TotalBill);
